export default __webpack_public_path__ + "static/media/METAMORPHOSIS.7cbf71af.png";